export class GestionAfiliado_Beneficiados {
    id: number;
    nroDocumento: string;
    nombres: string;
    apellidos: string;
    parentesco: number;
    parentescoDescripcion: string;
    participacion: number;
    tipoBeneficiario: number;
    tipoBeneficiarioDescripcion: string;
    tipoIdentificacion: string;
    tipoIdentificacionDescripcion: string;
    raza: string;
    nacimiento: Date;
    edad: number;
    color: string;
    genero: number;
    generoDescripcion: string;
}